import { render, staticRenderFns } from "./TestDemoForm.vue?vue&type=template&id=63c55870"
import script from "./TestDemoForm.vue?vue&type=script&lang=js"
export * from "./TestDemoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports